import { render, staticRenderFns } from "./AreaProtegidaForm.vue?vue&type=template&id=6f1dc4b8&"
import script from "./AreaProtegidaForm.vue?vue&type=script&lang=js&"
export * from "./AreaProtegidaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports